module.exports = __webpack_public_path__ + "static/feature-required-8460ac6c46a2667068fe9c093241439a.png";